import ErrorChanged from "../actions/error-changed";
import { mergeMap, filter, tap } from "rxjs/operators";
import { of } from "rxjs";
import { logReduxError } from "utils";

const handleAllErrorsEffect = (action$, state$) =>
	action$.pipe(
		filter((action) => action.type.includes("_FAILED")),
		tap((action) => {
			// Extract user information from state
			const profile = state$.value?.profile;
			const organisations = state$.value?.organisations;
			const currentOrganisationId = organisations?.currentOrganisation;
			const currentOrganisation = organisations?.data?.find(org => org.id === currentOrganisationId);
			
			const user = profile ? {
				id: profile.userId || profile.id,
				username: profile.userName || profile.username,
				email: profile.email,
				organisationId: currentOrganisationId,
				organisationName: currentOrganisation?.name,
			} : null;

			// Log error to Rollbar
			logReduxError(action, user);
		}),
		mergeMap((action) => of(ErrorChanged(action.payload)))
	);

export default handleAllErrorsEffect;
